import classNames from 'classnames';
import { Icon, IconProps } from '~/components/Icon/Icon';

export type MediumProps = IconProps;
export const Medium = ({ className, ...props }: MediumProps) => (
  <Icon
    className={classNames('medium', className)}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.5273 11.8102C13.5273 15.5712 10.499 18.6201 6.76374 18.6201C3.02845 18.6201 0 15.5712 0 11.8102C0 8.04913 3.02822 5 6.76374 5C10.4993 5 13.5273 8.04913 13.5273 11.8102ZM20.9651 11.8081C20.9651 15.3483 19.451 18.2194 17.5832 18.2194C15.7155 18.2194 14.2014 15.3483 14.2014 11.8081C14.2014 8.26793 15.7153 5.39689 17.583 5.39689C19.4508 5.39689 20.9649 8.26701 20.9649 11.8081H20.9651ZM22.8105 17.5515C23.4675 17.5515 23.9999 14.9792 23.9999 11.808C23.9999 8.63594 23.4673 6.06455 22.8105 6.06455C22.1538 6.06455 21.6214 8.63617 21.6214 11.808C21.6214 14.9799 22.1536 17.5515 22.8105 17.5515Z"
      fill="currentColor"
    />
  </Icon>
);
